import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Shell } from './layout/Shell';
import { definirAoExpirar } from './lib/api';
import { useEu } from './lib/consultas';
import { CadastroPublico } from './paginas/cadastro/CadastroPublico';
import { Configuracoes } from './paginas/configuracoes/Configuracoes';
import { Contatos } from './paginas/contatos/Contatos';
import { Cotacao } from './paginas/cotacao/Cotacao';
import { Pedidos } from './paginas/pedidos/Pedidos';
import { Treino } from './paginas/treino/Treino';
import { Conversas } from './paginas/conversas/Conversas';
import { Login } from './paginas/Login';

export function App() {
  const local = useLocation();
  if (local.pathname.startsWith('/cadastro/'))
    return (
      <Routes>
        <Route path="/cadastro/:codigo" element={<CadastroPublico />} />
      </Routes>
    );
  return <Central />;
}

function Central() {
  const qc = useQueryClient();
  const navegar = useNavigate();
  const eu = useEu();

  useEffect(() => {
    definirAoExpirar(() => {
      qc.clear();
      navegar('/entrar', { replace: true });
    });
  }, [qc, navegar]);

  if (eu.isPending) return null;

  return (
    <Routes>
      <Route path="/entrar" element={eu.data ? <Navigate to="/conversas" replace /> : <Login />} />
      <Route element={eu.data ? <Shell eu={eu.data} /> : <Navigate to="/entrar" replace />}>
        <Route path="/conversas/:id?" element={<Conversas eu={eu.data!} />} />
        <Route path="/contatos/:id?" element={<Contatos eu={eu.data!} />} />
        <Route path="/cotacao" element={<Cotacao />} />
        <Route path="/treino/analise/:analiseId" element={<Treino eu={eu.data!} />} />
        <Route path="/treino/:id?" element={<Treino eu={eu.data!} />} />
        <Route path="/pedidos" element={<Pedidos />} />
        <Route path="/configuracoes/*" element={<Configuracoes eu={eu.data!} />} />
        <Route path="*" element={<Navigate to="/conversas" replace />} />
      </Route>
    </Routes>
  );
}
